<template>
    <v-layout column fill-height style="height: 100%;display: flex;flex-direction: column;">

        <v-toolbar light class="elevation-1" style="flex: 0 1 64px;">

            <v-btn icon @click="$emit('close')">
                <v-icon>close</v-icon>
            </v-btn>

            <v-tabs v-model="tab"
                align-with-title grow
                color="transparent"
                slider-color="primary"
                height="64"
            >

                <v-tab :href="`#tab-info`">
                    {{$t('File Info')}}
                </v-tab>

                <v-tab :href="`#tab-history`">
                    {{$t('History')}}
                </v-tab>

                <v-tab :href="`#tab-chat`">
                    {{$t('Chat')}}
                </v-tab>

            </v-tabs>

        </v-toolbar>

        <v-container class="no-padding" style="width: 100%;flex: 1 1 auto;overflow: hidden;display: flex;">

            <v-tabs-items v-model="tab" class="fill-height" style="width: 100%;align-items: stretch;height: auto;">

                <v-tab-item :value="`tab-info`" class="fill-height" style="overflow-y: auto">
                    <FileInfo :fileData="file" :token="token" :hash="file.hash"></FileInfo>
                </v-tab-item>

                <v-tab-item :value="`tab-history`" class="fill-height">
                    <FileHistory ref="file_history" :canRevoke="false" :canEdit="false" small/>
                </v-tab-item>

                <v-tab-item :value="`tab-chat`" class="fill-height">
                    <Comments :hash="file.hash" :token="token"/>
                </v-tab-item>

            </v-tabs-items>

        </v-container>

    </v-layout>
</template>

<script>

    import { VContainer, VLayout, VTabsItems, VTabItem, VTab, VTabs, VBtn, VIcon, VToolbar } from 'vuetify/lib'
    import Comments from "./Comments";
    import FileInfo from "./FileInfo";
    import FileHistory from "./FileHistory";
    import FilesRepository from '../repositories/FilesRepository';

    export default {
        name: 'FileInfoDrawer',
        components: {
            FileInfo,
            Comments,
            VLayout, VTabsItems, VTabItem, VTab, VTabs, VBtn, VIcon, VToolbar, VContainer, FileHistory
        },
        data () {
            return {
                tab: "tab-info"
            }
        },
        props: {
            file: Object,
            token: String,
        },
        created () {
            this.getFileDetails();
        },
        methods: {
            setTab(tab) {
                this.tab = tab;
            },
            getFileDetails() {
                FilesRepository.getFileDetails(this.$route.params.hash, this.token)
                    .then((response)=>{
                        if (response && response.data && response.data.file && response.data.file.actions){
                            this.$refs.file_history.setItems(response.data.file.actions);
                        }
                    });
            },
        }
    }
</script>

<style lang="scss">
    .v-tabs__container--align-with-title {
        padding-left: 0!important;
    }
</style>